import { SIZE_OVERRIDE } from "constants/action-types";
import { handleActions } from "redux-actions";
import { ISizeOverride } from "../containers/management/management-types";

const initialState = {
    sizeOverrides: [],
    isAdding: false,
    isDeleting: false,
    isFetching: false,
    isUpdating: false,
    sizeOverridesError: undefined,
};

interface IState {
    sizeOverrides: ISizeOverride[];
    isAdding: boolean;
    isFetching: boolean;
    isUpdating: boolean;
    sizeOverridesError: any;
}

export const productSizeOverrides = handleActions(
    {
        [SIZE_OVERRIDE.FETCH.START]: (state: IState): IState => {
            return {
                ...state,
                isFetching: true,
            };
        },
        [SIZE_OVERRIDE.FETCH.SUCCESS]: (state: IState, { payload }: any): IState => {
            return {
                ...state,
                sizeOverrides: payload,
                isFetching: false,
            };
        },
        [SIZE_OVERRIDE.FETCH.ERROR]: (state: IState, { payload }: any): IState => {
            return {
                ...state,
                isFetching: false,
                sizeOverridesError: payload.error,
            };
        },
        [SIZE_OVERRIDE.CREATE.START]: (state: IState): IState => {
            return {
                ...state,
                isAdding: true,
            };
        },
        [SIZE_OVERRIDE.CREATE.COMPLETED]: (state: IState, { payload, error }: any): IState => {
            if (error) {
                return {
                    ...state,
                    isAdding: false,
                    sizeOverridesError: error,
                };
            }
            return {
                ...state,
                sizeOverrides: [...state.sizeOverrides, payload],
                isAdding: false,
            };
        },
        [SIZE_OVERRIDE.DELETE.START]: (state: IState) => {
            return {
                ...state,
                isDeleting: true,
            };
        },
        [SIZE_OVERRIDE.DELETE.COMPLETED]: (state: IState, { payload, error }: any) => {
            if (error) {
                return {
                    ...state,
                    familiesError: payload.error,
                    isDeleting: false,
                };
            }
            const { _id } = payload;
            return {
                ...state,
                sizeOverrides: state.sizeOverrides.filter((f) => f._id !== _id),
                isDeleting: false,
            };
        },
        [SIZE_OVERRIDE.UPDATE.START]: (state: IState) => {
            return {
                ...state,
                isUpdating: true,
            };
        },
        [SIZE_OVERRIDE.UPDATE.COMPLETED]: (state: IState, { payload, error }: any) => {
            if (error) {
                return {
                    ...state,
                    familiesError: payload.error,
                    isUpdating: false,
                };
            }
            const sizeOverrides = state.sizeOverrides.slice();
            const index = sizeOverrides.findIndex((f) => f._id === payload._id);
            sizeOverrides.splice(index, 1, payload);

            return {
                ...state,
                sizeOverrides,
                isUpdating: false,
            };
        },
    },
    initialState
);
